<h2>Crear Consulta</h2> 
<div mat-dialog-content>
    <p>
        Complete el siguiente formulario para ingresar una consulta.
    </p>
    <!-- <table class="table-consulta">
        <tr>
            <td>Asunto</td>
            <td><input type="text"></td>
        </tr>
        <tr>
            <td>Consulta</td>
            <td><input type="text"></td>
        </tr>
    </table>    -->
    <form [formGroup]="formConsulta" autocomplete="on" novalidate 
        (ngSubmit)="enviarConsulta(formConsulta.value)"> 
        <table class="table-contacto">
            <tr>
                <td>Asunto</td>
                <td>
                    <mat-form-field>
                        <input matInput type="text" formControlName="titulo" id="titulo">
                        <mat-error *ngIf="hasError('titulo', 'required')">Asunto es requiredo</mat-error>
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <td>Consulta</td>
                <td>
                    <mat-form-field appearance="fill">
                        <textarea matInput formControlName="pregunta" id="pregunta"></textarea>
                        <mat-error *ngIf="hasError('pregunta', 'required')">Consulta es requiredo</mat-error>
                        </mat-form-field>
                </td>
            </tr>
            <tr>
                <td></td>
                <td class="td-btn"> 
                    <button mat-button class="btn-cancelar">Cancelar</button>
                    <button mat-button class="btn-confirmar" [disabled]="agregarConsulta">Agregar</button>
                </td>
            </tr>
        </table>
    </form> 
</div>

<!-- <div mat-dialog-actions>
  <button mat-button mat-dialog-close class="btn-cancelar">Cancelar</button>
  <button mat-button class="btn-confirmar">Agregar</button>
</div> -->